import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

const MyDataDesktopSkeleton = () => (
  <ContentLoader
    speed={3}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    <Rect x="0.5%" y="3.5vh" rx="0" ry="0" width="100%" height="58vh" />
    <Rect x="1%" y="63vh" rx="3" ry="3" width="35%" height="6vh" />
    <Rect x="1%" y="71vh" rx="3" ry="3" width="35%" height="6vh" />
    <Rect x="1%" y="79vh" rx="3" ry="3" width="35%" height="6vh" />
  </ContentLoader>
)

export default MyDataDesktopSkeleton
